import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function AboutpageBanner() {
  const container = {
    hidden: {},
    visible: {
      transition: {
        delayChildren: 0.5,
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1, duration: 0.1, ease: "easeInOut" }}
      className="relative w-full h-[400px] md:h-screen overflow-hidden flex justify-center items-center bg-black"
    >
      <div className="text-white text-center">
        {/* Mobile Buttons - Show only on small screens */}
        <div className="md:hidden flex flex-col items-center gap-4 mb-6">
          <Link
            data-aos="fade-right"
            to="/contact"
            aria-label="Contact"
            className="group relative inline-flex h-14   tracking-widest  items-center rounded-full px-6 py-6 text-[1rem] font-semibold text-white bg-transparent overflow-hidden"
          >
            <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
              <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
              </span>
            </span>
            <span className="relative">
              <span className="flex flex-row gap-2 justify-center  items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                Contact Us Now
              </span>
              <span className="absolute flex flec-row gap-2 top-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                Contact Us Now
              </span>
            </span>
          </Link>{" "}
        </div>

        <h1 className="leading-[1.8rem] md:leading-normal xl:leading-[4.5rem] 2xl:leading-[6.5rem]">
          {/* Line 2 */}
          <motion.div
            className="md:flex hidden justify-center text-[25px] md:text-5xl lg:text-6xl xl:text-[6vw] 2xl:text-[6vw] leading-[50px] xl:leading-[40px] items-center md:pb-8 md:pt-10 2xl:pb-20 2xl:pt-32 font-robout"
            variants={container}
            initial="hidden"
            animate="visible"
          >
            {"Radiologist Owned & Operated".split("").map((char, i) => (
              <motion.span variants={item} key={i + 40}>
                {char === " " ? "\u00A0" : char}
              </motion.span>
            ))}
          </motion.div>
          <motion.div
            className="md:hidden flex justify-center text-2xl tracking-wide  items-center mb-3 font-robout"
            variants={container}
            initial="hidden"
            animate="visible"
          >
            Radiologist Owned & Operated
          </motion.div>

          {/* Line 3 */}
          <motion.div
            className="md:flex hidden flex-wrap justify-center  md:leading-10 leading-[50px] mx-6 md:mx-0 items-center 2xl:mt-8 sm:mt-6 font-black sm:text-4xl text-center text-[20px] md:text-3xl lg:text-4xl xl:text-[3.3vw] 2xl:text-[2.85vw] font-robout"
            variants={container}
            initial="hidden"
            animate="visible"
          >
            {"Citrus County, Florida's Premier Imaging Provider".split("").map(
              (char, i) => (
                <motion.span variants={item} key={i + 60}>
                  {char === " " ? "\u00A0" : char}
                </motion.span>
              )
            )}
          </motion.div>
          <motion.div data-aos="fade-up"
            className="flex md:hidden flex-wrap justify-center tracking-wide mx-6 items-center  sm:mt-6 sm:text-2xl text-center text-xl  font-robout"
            variants={container}
            initial="hidden"
            animate="visible"
          >
            Citrus County, Florida's Premier Imaging Provider

          </motion.div>
        </h1>
      </div>
    </motion.div>
  );
}
